<template>
    <footer class="footer page-footer">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ul class="list-unstyled list-inline">
<!--                    <ul class="list-unstyled list-inline" v-if="showFooterLinks">-->
                        <li class="list-inline-item">
                          <router-link :to="{name: 'Terms'}">{{$t('bp.policy.p2')}}</router-link>
                        </li>
                        <li class="list-inline-item">
                          <router-link :to="{name: 'Privacy'}">{{$t('bp.privacyPolicy')}}</router-link>
                        </li>
                        <li class="list-inline-item" v-if="carrier === 'samsungrepair-de'">
                            <a href="https://www.samsung-repair.de/de/impressum" target="_blank">{{$t('bp.legal')}}</a>
                        </li>
                        <li class="list-inline-item">
                            <router-link v-if="carrier !== 'likewize-au' && carrier !== 'likewize-us' && carrier !== 'samsungrepair-de'" :to="{name: 'Faqs'}">{{$t('bp.help')}}</router-link>
                            <a v-if="carrier === 'likewize-au'" href="https://likewizerepair.com.au/help">{{$t('bp.help')}}</a>
                            <a v-if="carrier === 'likewize-us'" href="https://likewizerepair.com/help">{{$t('bp.help')}}</a>
                            <a v-if="carrier === 'samsungrepair-de'" href="https://www.samsung-repair.de/de/faqs">{{$t('bp.help')}}</a>
                        </li>
                    </ul>
                    <p>
                        &copy; {{currentYear}} {{ carrierDetails.address }}
                    </p>
                    <ul class="list-unstyled list-inline mb-0">
                        <li class="list-inline-item" v-if="carrierDetails.registrationDetails">
                            {{ carrierDetails.registrationDetails }}
                        </li>
                        <li class="list-inline-item" v-if="allowsInStoreBooking">
                            <router-link :to="{name: 'storeSearch'}" target="_blank">Store Login</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            currentYear: new Date().getFullYear()
        };
    },

    computed: {
        ...mapGetters([
            'carrier',
            'carrierDetails',
            'allowsStoreDropOff',
            'allowsInStoreBooking',
            'countryCodeSetting'
        ]),

        // showFooterLinks() {
        //     if (this.carrierDetails.termsLink ||
        //         this.carrierDetails.privacyLink ||
        //         this.carrier === 'vodafone') {
        //         return true;
        //     }
        //
        //     return false;
        // }
    }
};
</script>

<style scoped>

</style>
